export enum Destinations {
    Content,
    Courses,
    CourseCategory,
    MainPageSubmenu
}